<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content content-with-nav pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero title="Aard van de plechtigheid" />

    <!-- Content -->
    <v-row justify="center">
      <v-col
        class="center"
        cols="12"
        md="8"
        lg="6"
      >
        <p class="aard-info">
          Wenst u:
        </p>
        <v-select
          v-model="algemeneInfo.aardPlechtigheidValue"
          base-color="primary"
          bg-color="white"
          color="primary"
          density="compact"
          item-title="longDescription"
          item-value="value"
          :items="aardPlechtigheidOpties"
          label="Keuze"
          variant="outlined"
        />
        <v-textarea
          v-model="algemeneInfo.aardPlechtigheidAndere"
          auto-grow
          base-color="primary"
          bg-color="white"
          color="primary"
          density="compact"
          :disabled="algemeneInfo.aardPlechtigheidValue !== constantMixin.codes.aardPlechtigheid.values.andere"
          rows="3"
          variant="outlined"
        />
        <div class="d-flex justify-end">
          <v-btn
            color="primary"
            rounded
            @click="SaveGeneralInfo"
          >
            <v-icon
              class="mr-1"
              size="18"
            >
              mdi-content-save-outline
            </v-icon>
            Opslaan
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Navigation -->
    <div class="samenstellen-nav">
      <div class="samenstellen-nav-inner">
        <v-btn
          v-if="samenstellenNavigation_PreviousItem"
          color="primary"
          :disabled="samenstellenNavigation_PreviousItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToPrevious"
        >
          <v-icon start>
            mdi-chevron-left
          </v-icon>
          {{ samenstellenNavigation_PreviousItem.title }}
        </v-btn>
        <span v-else />
        <v-btn
          v-if="samenstellenNavigation_NextItem"
          color="primary"
          :disabled="samenstellenNavigation_NextItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToNext"
        >
          {{ samenstellenNavigation_NextItem.title }}
          <v-icon end>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <span v-else />
      </div>
    </div>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import samenstellenNavigationMixin from '@/mixins/samenstellenNavigationMixin'
import klantService from '@/services/klantService'

export default {
  name: 'AardVanDePlechtigheidComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin,
    commonMixin,
    constantMixin,
    errorMixin,
    samenstellenNavigationMixin
  ],
  data () {
    return {
      aardPlechtigheidOpties: [],
      algemeneInfo: {}
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
    klantService.Init(this)
    this.LoadData()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  methods: {
    async LoadData () {
      this.CommonMixin_Load(this.$options.name, true)
      await Promise.all([
        this.GetAardPlechtigheidOpties(),
        this.GetUitvaartDraaiboek()
      ])
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetAardPlechtigheidOpties () {
      const resp = await klantService.GetUitvaartDraaiboekListCode()

      if (resp?.data) {
        this.aardPlechtigheidOpties = resp.data.filter(o => o.type === this.constantMixin.codes.aardPlechtigheid.name)
      }
    },
    async GetUitvaartDraaiboek () {
      const resp = await klantService.GetUitvaartDraaiboek()

      if (resp && (resp.data || resp.data !== '')) {
        this.algemeneInfo = resp.data
      }
    },
    async SaveGeneralInfo () {
      this.CommonMixin_Load(this.$options.name, true)

      if (this.algemeneInfo.aardPlechtigheidValue !== this.constantMixin.codes.aardPlechtigheid.values.andere) {
        this.algemeneInfo.aardPlechtigheidAndere = null
      }

      await klantService.SaveUitvaartDraaiboek(this.algemeneInfo)
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.aard-info {
  font-size: 15px;
  color: #424E58;
  padding: 0;
  margin: 0 0 8px 0;
}
</style>
